class ClientFilterUIState {
  constructor(indexes) {
    this.indexes = indexes;

    this.selectedValueIdsByFieldId = new Map();

    this.visibleValueIdsByFieldId = new Map();

    this.initialize();
  }

  initialize() {
    this.indexes.fieldValueIdsByFieldId.forEach((valueIds, fieldId) => {
      this.visibleValueIdsByFieldId.set(fieldId, [...valueIds]);
    });
  }

  initializeSelections(currentFilterValues) {
    currentFilterValues.forEach((cfv) => {
      if (!cfv.selected) {
        return;
      }

      const fieldId = cfv.setFieldId;
      const fieldValueId = cfv.setFieldValueId;

      if (!this.selectedValueIdsByFieldId.has(fieldId)) {
        this.selectedValueIdsByFieldId.set(fieldId, new Set());
      }
      this.selectedValueIdsByFieldId.get(fieldId).add(fieldValueId);
    });
  }
}

export default ClientFilterUIState;
